import React, { useState } from "react"
import { Button, Layout, Menu, Divider } from 'antd';
import {
  ContainerOutlined,
  LogoutOutlined,
  BookOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { Link } from "react-router-dom"
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { logout } from "../actions/authActions";
import { connect } from "react-redux";
import dashboardIcon from '../Assets/images/sidebar-icons/Dashboard.svg'
import bookingDeatilsIcon from '../Assets/images/sidebar-icons/booking.svg'
import createBookingIcon from '../Assets/images/sidebar-icons/patient-details.svg'
import himsIcon from '../Assets/images/sidebar-icons/HIMS.svg'
import settingsIcon from '../Assets/images/sidebar-icons/Settings.svg'
import logoutIcon from '../Assets/images/sidebar-icons/logout.svg'
import FullLogo from '../Assets/images/plunes-logo-text.png'
import logoIcon from '../Assets/images/logo.png'
import { useEffect } from 'react';

const { Sider } = Layout;

const SideBar = (props) => {
  // console.log(props,"props in SideBar")
  const [navbarOpen, setNavbarOpen] = useState(false)
  const [sideBarActiveKey, setSideBarActiveKey] = useState('1')
  
  useEffect(() => {
    const pathName = window.location.pathname
    if(pathName==='/dashboard') {
      setSideBarActiveKey('4')
    } else if (pathName.startsWith('/dashboard/booking-details') || pathName.startsWith('/dashboard/final-bill')) {
      setSideBarActiveKey('1')
    } else if (pathName==='/dashboard/create-booking') {
      setSideBarActiveKey('2')
    } else if (pathName==='/dashboard/hospital-details') {
      setSideBarActiveKey('6')
    } else if (pathName==='/dashboard/reset-password') {
      setSideBarActiveKey('7')
    }  else if (pathName==='/dashboard/hims') {
      setSideBarActiveKey('8')
    } 
  }, [window.location.pathname])

  return (<>
    <div style={{ position: 'absolute', top: '0', left: '0', width: '260px', height: '64px', zIndex: '301', background: 'white', borderBottom: '1px solid #CCCBCB', borderRight:'1px solid #CCCBCB' }}>
      <a href="/dashboard"><img src={FullLogo} alt="logo" style={{ height: '38px', width: 'auto', marginLeft: '2.5rem', marginTop: '1rem', display: 'block' }} /></a>
    </div>
    <Sider style={{ height: "100vh", zIndex: `${navbarOpen ? '200' : '0'}` }}
    className="site-layout-background side-bar-container">
    <Menu
      mode="inline"
      defaultSelectedKeys={[props.activeKey]}
      selectedKeys={[sideBarActiveKey]}
      onMouseEnter={() => setNavbarOpen(true)} onMouseLeave={() => setNavbarOpen(false)}
      // style={{ height: '100%', width: `${navbarOpen ? '260' : '75'}px`, marginTop: '64px' }}
      style={{ height: 'calc(100vh - 64px)', width: `${navbarOpen ? '260' : '75'}px`, marginTop: '64px' }}
    >
      <Menu.ItemGroup>
      {/* <p style={{margin:'2rem 0 2rem 1.5rem', fontSize:'16px', fontWeight:'600', color:'#111111'}}>MENU</p> */}
      <Menu.Item key="4" className={`${navbarOpen ? 'hover-open' : ''}`}><Link to="/dashboard"><img src={dashboardIcon} className="img-icon" alt="icon" />{ navbarOpen && "Dashboard" }</Link></Menu.Item>
      <Menu.Item key="1" className={`${navbarOpen ? 'hover-open' : ''}`}><Link to="/dashboard/booking-details"><img src={bookingDeatilsIcon} className="img-icon" alt="icon" />{ navbarOpen && "Patient Details" }</Link></Menu.Item>
      <Menu.Item key="2" className={`${navbarOpen ? 'hover-open' : ''}`}><Link to="/dashboard/create-booking"><img src={createBookingIcon} className="img-icon" alt="icon" />{ navbarOpen && "Submit Patient Details" }</Link></Menu.Item>
      </Menu.ItemGroup>
      <Menu.Divider style={{border:'1px solid #DAE3F8'}}/>
      {/* <Menu.Item key="5" className={`${navbarOpen ? 'hover-open' : ''}`}><Link to="/dashboard/settings"><img src={settingsIcon} className="img-icon" alt="icon" />{ navbarOpen && "Settings" }</Link></Menu.Item> */}
      <Menu.SubMenu key='5' title={<><img src={settingsIcon} className="img-icon" alt="icon" />{ navbarOpen && <span>Settings</span> }</>} style={{maxHeight:'max-content'}} className={navbarOpen ? 'sub-menu-hover-open' : 'sub-menu-items-closed'}>
        <Menu.Item key="6" className={`${navbarOpen ? 'hover-open' : ''}`}><Link to="/dashboard/hospital-details">{ navbarOpen && "Hospital Details" }</Link></Menu.Item>
        <Menu.Item key="7" className={`${navbarOpen ? 'hover-open' : ''}`}><Link to="/dashboard/reset-password">{ navbarOpen && "Reset Password" }</Link></Menu.Item>
      </Menu.SubMenu>
      {/* <Menu.Item key="8" className={`${navbarOpen ? 'hover-open' : ''}`}><Link to="/dashboard/hims"><img src={himsIcon} className="img-icon" alt="icon" />{ navbarOpen && "HIMS" }</Link></Menu.Item> */}
      <Menu.Item key="3" style={{paddingLeft: "16px"}} className={`logut-menu-item ${navbarOpen ? 'hover-open' : ''}`}> <Button className="logout-btn" onClick={() => {
        props.logout()
        window.location.href = "/auth"
      }}><img src={logoutIcon} className="img-icon" alt="icon" />{ navbarOpen && "Log out" }</Button>
      </Menu.Item>

    </Menu>
  </Sider></>)
}
const mapStateToProps = (state) => ({
  user: state.authStore,
});


export default connect(mapStateToProps, {
  logout
})(SideBar)